import { onMounted, ref } from 'vue'

export function useScrollIntoView() {
  const elementRef = ref<HTMLElement | null>(null)

  onMounted(() => {
    if (elementRef.value) {
      elementRef.value.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  })

  return { elementRef }
}
